import React from "react";

function About() {
  return (
    <section className="tc-about-style7">
      <div className="container">
        <div className="row gx-0 justify-content-between">
          <div className="col-lg-3">
            <div className="rotate-box" data-speed="1" data-lag="0.4">
              <a className="rotate-circle fsz-30 rotate-text d-inline-block text-uppercase">
                <svg className="textcircle" viewBox="0 0 500 500">
                  <defs>
                    <path
                      id="textcircle"
                      d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
                    ></path>
                  </defs>
                  <text>
                    <textPath xlinkHref="#textcircle" textLength="900">
                      Tetra Yapı - Atölye Line -
                    </textPath>
                  </text>
                </svg>
              </a>
              <img
                src="/innerpages/assets/img/leafs.png"
                alt=""
                className="icon"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="info" id="about-tetra">
              <div className="text fsz-20 fw-500 mb-20">
                Projelerimiz, Tetra Yapı’nın yaratıcı ve deneyimli mimar ve
                mühendisleri tarafından özenle tasarlanmış ve hayata geçirilmiş
                özgün ve kaliteli çalışmaları içerir. Her bir proje, estetik,
                fonksiyonellik ve çevresel sürdürülebilirlik gibi önemli
                unsurları bir araya getirerek, inşaat sektöründe standartları
                yükseltme misyonumuzun birer yansımasıdır.
              </div>
              <div className="text fsz-20 fw-500 mb-30">
                Tetra Yapı’nın projeleri, her aşamasında kalite, güvenlik ve
                estetik açıdan titizlikle denetlenir. Bu sayede, müşterilerimize
                sadece fonksiyonel ve güvenilir mekanlar sunmakla kalmayıp, aynı
                zamanda hayal ettikleri yaşam alanlarını oluşturma fırsatı
                veririz. Web sitemizde projelerimizi yakından tanıyabilir,
                bizimle iletişime geçerek hayallerinizi gerçeğe dönüştürmek için
                nasıl yardımcı olabileceğimizi öğrenebilirsiniz.
              </div>
            </div>
          </div>
          <div className="col-lg-2">
            <div className="numbers mt-5 mt-lg-0">
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.4s"
              >
                <h2 className="numb"> 92% </h2>
                <small>
                  {" "}
                  Memnuniyet oranı ve öneriyle gelen yeni müşteriler{" "}
                </small>
              </div>
              <div
                className="number-card wow zoomIn slow"
                data-wow-delay="0.6s"
              >
                <h2 className="numb"> 30+ </h2>
                <small> Gaziantep’te tamamlanan konut ve villa projesi </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
